import { AfterViewInit, Component } from '@angular/core';
import { AppStateHandlerService } from 'modules/app/services/app-state-handler.service';



@Component({
    selector: 'autoupdate-error-modal',
    styleUrls: ['./autoupdate-error-modal.style.scss'],
    templateUrl: './autoupdate-error-modal.template.html',
	standalone: false
})
export class AutoupdateErrorModal implements AfterViewInit {

    showModal = false;
    public imageBasePath: string = IMAGES_BASEPATH;

    constructor(
        private appStateHandlerService: AppStateHandlerService,
    ) { }


    ngAfterViewInit() {
        document.querySelector('#app-updater-modal').addEventListener('open-modal',() => {
            this.showModal = true;
        });

    }

    closeModal() {
        this.showModal = false;
    }

    closeModalAndQuitApp() {
        this.appStateHandlerService.quitApp();
    }

}